import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import {Card} from "primereact/card";
import {Dialog} from "primereact/dialog";
import UploadFileInstrument from "../../../components/uploadFile/uploadFileInstrument";
import PropTypes from "prop-types";

const MassiveAgreementView = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}
                   className={"Paper"}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Concertación Masiva"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getMessages}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item xs={12}>
                                    <div className="p-grid">
                                        <div className="p-col-2">
                                            <SubtitleLabel header="Prestamista" isBold={true}/>
                                            <Dropdown
                                                name="lender"
                                                filterBy="lender"
                                                optionLabel="lender"
                                                placeholder="Seleccione..."
                                                options={props.catalogs.catLender}
                                                onChange={props.onChangeFilters}
                                                value={props.filters.lender}/>
                                        </div>
                                        <div className="p-col-2">
                                            <SubtitleLabel header="Prestatario" isBold={true}/>
                                            <Dropdown
                                                name="borrower"
                                                filterBy="borrower"
                                                optionLabel="borrower"
                                                placeholder="Seleccione..."
                                                options={props.catalogs.catBorrower}
                                                onChange={props.onChangeFilters}
                                                value={props.filters.borrower}/>
                                        </div>
                                        <div className="p-col-2">
                                            <SubtitleLabel header="Emisora" isBold={true}/>
                                            <Dropdown
                                                name="instrument"
                                                filterBy="instrument"
                                                optionLabel="label"
                                                placeholder="Seleccione..."
                                                options={props.catalogs.catInstrument}
                                                onChange={props.onChangeFilters}
                                                value={props.filters.instrument}/>
                                        </div>
                                        <div className="p-col-2">
                                            <SubtitleLabel header="Folio Origen" isBold={true}/>
                                            <InputText name="idOrigin" placeholder="Ex: 99,99"
                                                       maxLength={10}
                                                       onChange={props.onChangeFilters}
                                                       value={props.filters.idOrigin}/>
                                        </div>
                                        <div className="p-col-2">
                                            <SubtitleLabel header="Folio Preval" isBold={true}/>
                                            <InputText name="idPresval" placeholder="Ex: 99,99"
                                                       maxLength={10}
                                                       onChange={props.onChangeFilters}
                                                       value={props.filters.idPresval}/>
                                        </div>
                                        <div className="p-col-2">
                                            <SubtitleLabel header="Estado" isBold={true}/>
                                            <Dropdown
                                                name="status"
                                                filterBy="status"
                                                optionLabel="status"
                                                placeholder="Seleccione..."
                                                options={props.catalogs.catStatus}
                                                onChange={props.onChangeFilters}
                                                value={props.filters.status}/>
                                        </div>
                                        <div className="p-col-12">
                                            <br/>
                                            <Button label="Limpiar"
                                                    style={{'float': 'right'}}
                                                    onClick={props.clearFilters}
                                                    className="p-button-secondary"/>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Garantizar" className="p-button-secondary"
                                    style={{visibility: 'hidden'}}
                                    onClick={props.setGuarantees}/>&nbsp;
                            <UploadFileInstrument type={["text/csv", "text/plain"]} size="1000000"
                                               urlAction="/stance/preMatch/upload"
                                               errorTypeMessage="El documento debe ser csv."
                                               errorSizeMessage="El archivo es muy pesado."
                                               instructions="Debe ser un archivo de texto con comas de separación entre los datos."
                                               titleHeader="Selección de archivo"
                                               titleButton="Importar"
                                                  loadingFunc={props.loading}
                                               />&nbsp;
                            <Button label="Eliminar"
                                    onClick={props.openConfMsg}
                                    className="p-button-secondary"/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.messagesList}
                            selection={props.selectedMessages}
                            onSelectionChange={props.onSelectionChangeTable}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column selectionMode="multiple"
                                style={{width: '4em', textAlign: 'center'}} />
                            <Column field="idOrigin" header="Folio Origen"
                                style={{textAlign: 'right'}}
                                sortable={true} />
                            <Column field="lender" header="Prestamista"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="lenderAccount" header="Prestamista Cuenta"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="borrower" header="Prestatario"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="borrowerAccount" header="Prestatario Cuenta"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="valueType" header="Tipo Valor"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="instrument" header="Emisora"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="series" header="Serie"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="coupon" header="Cupón"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="price" header="Precio"
                                style={{textAlign: 'right'}}
                                sortable={true} />
                            <Column field="titles" header="Titulos"
                                style={{textAlign: 'right'}} sortable={true}
                                    body={numberWithCommaDataTableTemplate} />
                            <Column field="term" header="Plazo"
                                style={{textAlign: 'right'}}
                                sortable={true} />
                            <Column field="tasa" header="Tasa"
                                style={{textAlign: 'right'}}
                                sortable={true} />
                            <Column field="sobreTasa" header="Sobretasa"
                                style={{textAlign: 'right'}}
                                sortable={true} />
                            <Column field="date"
                                header="Fecha"
                                style={{textAlign: 'left'}}
                                sortable={true} />
                            <Column field="status" header="Estado"
                                style={{textAlign: 'center'}} sortable={true}
                                    body={props.errorTemplate} />
                            <Column field="idPresval" header="Folio Presval"
                                style={{textAlign: 'right'}}
                                sortable={true} />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayGuaranteeDialog}
                    modal={true} closable={false}
                    contentStyle={{overflow:"visible"}} style={{width: "40%", overflow:"visible"}}
                    onHide={props.onHideGuaranteeDialog}
                    header={
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                                <h2> <b> Selección de garantía </b></h2>
                            </div>
                            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                                <Button label="Regresar" onClick={props.onHideGuaranteeDialog}
                                        className="p-button-secondary"/>
                            </div>
                            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                                <Button label="Guardar" onClick={props.saveGuarantee}/>
                            </div>
                        </div>
                    }>
                <div className="p-grid " style={{padding: "1.5em"}}>
                    <div className="p-col-12" >
                        <SubtitleLabel header="Garantía" isBold={true}/>
                        <Dropdown
                            name="instrument"
                            filterBy="instrument"
                            optionLabel="label"
                            placeholder="Seleccione..."
                            options={props.guarantees}
                            onChange={props.onChangeGuarantee}
                            value={props.selectedForGuarantee}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={props.displayErrorDialog}
                    modal={true} closable={false}
                    style={{width: "45%",}} onHide={props.onHideErrorDialog}
                    header={
                        <div className="p-grid p-fluid">
                            <div className="p-col-9" style={{padding: '.1em'}}>
                                <h2> <b> Error de procesamiento </b></h2>
                            </div>
                            <div className="p-col-3" style={{padding: '.2em'}}>
                                <Button label="Cerrar" onClick={props.onHideErrorDialog} />
                            </div>
                        </div>
                    }>
                <div className="p-grid " style={{padding: "1.5em"}}>
                    <div className="p-col-12">
                        <Card title={"Folio Origen: " + props.rowError.idOrigin} style={{padding: "1em"}}>
                            <p style={{
                                textAlign: "justify",
                                textJustify: "inter-word",
                                whiteSpace: "pre-line",
                            }}>
                                {props.rowError.errorMessage}
                            </p>
                        </Card>
                    </div>
                </div>
            </Dialog>

            {props.confirmationMessage}
        </React.Fragment>
    )
};
MassiveAgreementView.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.element.isRequired,
    clearFilters: PropTypes.func.isRequired,
    getMessages: PropTypes.func.isRequired,
    catalogs: PropTypes.array.isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    setGuarantees: PropTypes.func.isRequired,
    openConfMsg: PropTypes.func.isRequired,
    messagesList: PropTypes.array.isRequired,
    selectedMessages: PropTypes.array.isRequired,
    onSelectionChangeTable: PropTypes.func.isRequired,
    errorTemplate: PropTypes.element.isRequired,
    displayGuaranteeDialog: PropTypes.bool.isRequired,
    onHideGuaranteeDialog: PropTypes.func.isRequired,
    saveGuarantee: PropTypes.func.isRequired,
    guarantees: PropTypes.array.isRequired,
    onChangeGuarantee: PropTypes.func.isRequired,
    selectedForGuarantee: PropTypes.object,
    displayErrorDialog: PropTypes.bool.isRequired,
    onHideErrorDialog: PropTypes.func.isRequired,
    rowError: PropTypes.object,
    confirmationMessage: PropTypes.element,
    loading: PropTypes.func,
}
export default MassiveAgreementView;